export default "__VITE_ASSET__BwuXwuet__"